export const addToArrayKeepingMostRecentItems = (array, item, maxLength) => {
    // add new item to front and pull last item off if array is too long
    array.unshift(item);
    if (array.length > maxLength) {
        array.pop();
    }
};
//# sourceMappingURL=array_helpers.js.map